import { render, staticRenderFns } from "./admin.locations.edit.page.vue?vue&type=template&id=bfb9b1c6&scoped=true&"
import script from "./admin.locations.edit.page.vue?vue&type=script&lang=js&"
export * from "./admin.locations.edit.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.locations.edit.page.vue?vue&type=style&index=0&id=bfb9b1c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb9b1c6",
  null
  
)

export default component.exports